import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import _ from 'lodash'

Vue.use(Vuex)

let $api = process.env.VUE_APP_API_ROOT;

export default new Vuex.Store({
  state: {
    programmes: [],
    curriculums: [],
    programmeLevels: [],
    schoolLevels: [],
    programmeTypes: [],
    currentProgramme: { image: {} }
  },
  mutations: {
    setProgrammes(state, payload) {
      Vue.set(state, 'programmes', payload);
    },
    setProgramme(state, payload) {
      Vue.set(state, 'currentProgramme', payload);
    },
    setCurriculums(state, payload) {
      Vue.set(state, 'curriculums', payload);
    },
    setProgrammeLevels(state, payload) {
      Vue.set(state, 'programmeLevels', payload);
    },
    setSchoolLevels(state, payload) {
      Vue.set(state, 'schoolLevels', payload);
    },
    setProgrammeTypes(state, payload) {
      Vue.set(state, 'programmeTypes', payload);
    },
  },
  actions: {
    loadProgrammes({ commit, state }) {
      if (state.programmes.length > 0) {
        return;
      }

      return axios.get(`${$api}/education/programmes`).then(
        (result) => {
          commit('setProgrammes', result.data.programmes);
          commit('setCurriculums', result.data.curriculums);
          commit('setProgrammeLevels', result.data.levels);
          commit('setSchoolLevels', result.data.schoolLevels);
          commit('setProgrammeTypes', result.data.types);
        });
    },
    loadProgramme({ commit, state, dispatch }, slug) {
      return dispatch('loadProgrammes').then(() => {
        let programme = _.find(state.programmes, x => x.urlSegment == slug);

        commit('setProgramme', programme);
      });
    }
  }
})
